"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const Title_1 = __importDefault(require("antd/lib/typography/Title"));
const CheckBoldIcon_1 = __importDefault(require("mdi-react/CheckBoldIcon"));
const react_router_dom_1 = require("react-router-dom");
const PaymentStyled_1 = require("../../pages/paymentBooking/payment/PaymentStyled");
const suiteCollapseStyle_1 = require("./suiteCollapseStyle");
require("./SuiteTabs.scss");
const bed_white_svg_1 = __importDefault(require("../../assets/images/bed-white.svg"));
const bed_black_svg_1 = __importDefault(require("../../assets/images/bed-black.svg"));
const guest_svg_1 = __importDefault(require("../../assets/images/guest.svg"));
const SuiteFormRequired_1 = __importDefault(require("./suiteForm/SuiteFormRequired"));
const FormSuite_1 = require("../../hooks/FormSuite");
const SuiteForm_1 = __importDefault(require("./suiteForm/SuiteForm"));
const helpers_1 = require("../../utils/helpers");
const users_1 = require("../../utils/users");
const BookingService_1 = __importDefault(require("../../services/BookingService"));
const BookingRequestBuilder_1 = __importDefault(require("../../dtos/builder/BookingRequestBuilder"));
const BookingExceptionHandle_1 = __importDefault(require("../../exceptions/BookingExceptionHandle"));
const VehicleForm_1 = __importDefault(require("./suiteForm/VehicleForm"));
const CheckInCheckOut_1 = __importDefault(require("../checkInCheckOut/CheckInCheckOut"));
const message_utils_1 = __importDefault(require("../../utils/message_utils"));
const BookingReason_1 = __importDefault(require("./suiteForm/bookingReason/BookingReason"));
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const ConfirmValuesContext_1 = require("../../pages/paymentBooking/context/ConfirmValuesContext");
const ordinalNames = ['Primeiro', 'Segundo', 'Terceiro', 'Quarto', 'Quinto'];
const guestFieldsToValidate = ['fullname', 'documentGuest', 'birthday', 'email', 'phone'];
const SuiteTabs = ({ field, guestsQty, form, formsWithError, setRefundProtectEnabled, setShowRefundComponent, disableForm = false, setNeedDebitPhoneBR = () => undefined, setNeedPaymentDocCPF = () => undefined, initialFilledGuestsNumber = 0, suiteTitle = 'Suíte', formKey = 'suites', }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const history = (0, react_router_dom_1.useHistory)();
    const arrayID = ['1'];
    const { form: formSuite } = (0, FormSuite_1.useFormSuit)();
    const [show, setShow] = (0, react_1.useState)(false);
    const [requiredGuests, setRequiredGuests] = (0, react_1.useState)(Array(guestsQty - 1).fill(false));
    const [validGuests, setValidGuests] = (0, react_1.useState)(Array(guestsQty - 1).fill(true));
    const [filledGuestsNumber, setFilledGuestsNumber] = (0, react_1.useState)(0);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [suiteName, setSuiteName] = (0, react_1.useState)(suiteTitle);
    const [vehicleIsRequired, setVehicleIsRequired] = (0, react_1.useState)(false);
    const { TabPane } = antd_1.Tabs;
    const [tabActivePane, setTabActivePane] = (0, react_1.useState)('0');
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const { confirmValues } = confirmValuesContext;
        if ((_a = confirmValues === null || confirmValues === void 0 ? void 0 : confirmValues.suite) === null || _a === void 0 ? void 0 : _a.suiteTitle) {
            setSuiteName((_b = confirmValues === null || confirmValues === void 0 ? void 0 : confirmValues.suite) === null || _b === void 0 ? void 0 : _b.suiteTitle);
        }
        else {
            setSuiteName(suiteTitle);
        }
    }, [confirmValuesContext]);
    (0, react_1.useEffect)(() => {
        const hasError = !(formsWithError === null || formsWithError === void 0 ? void 0 : formsWithError.every(id => id !== field.key));
        if (hasError !== show) {
            setShow(hasError);
        }
    }, [formsWithError]);
    (0, react_1.useEffect)(() => {
        if (initialFilledGuestsNumber !== filledGuestsNumber) {
            setFilledGuestsNumber(initialFilledGuestsNumber);
        }
    }, [initialFilledGuestsNumber]);
    function setRequiredGuest(key, value) {
        setRequiredGuests(requiredGuests.map((isRequired, index) => (key === index ? value : isRequired)));
    }
    function setValidGuest(key, value) {
        setValidGuests(validGuests.map((isValid, index) => (key === index ? value : isValid)));
    }
    function validateAllGuests() {
        const guests = formSuite.getFieldValue([formKey, field.key, 'guests']);
        const fieldsToValidate = [
            ...guests.reduce((arrayTotal, guest, index) => [
                ...arrayTotal,
                ...guestFieldsToValidate.map(fieldName => [formKey, field.key, 'guests', index, fieldName]),
            ], []),
        ];
        formSuite
            .validateFields(fieldsToValidate)
            .then(() => {
            const newValidGuests = validGuests.map(() => true);
            setValidGuests(newValidGuests);
        })
            .catch(response => {
            var _a;
            const newValidGuests = validGuests.map(() => true);
            if ((_a = response.errorFields) === null || _a === void 0 ? void 0 : _a.length) {
                response.errorFields.forEach((error) => {
                    newValidGuests[error.name[3]] = false;
                });
            }
            setValidGuests(newValidGuests);
        });
    }
    const handleSubmitData = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const formValues = formSuite.getFieldsValue();
        const userEmail = (0, users_1.getUserData)().email;
        formValues.suites = formValues.suites.map(values => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (Object.assign(Object.assign({}, values), { addressCep: (_a = values.addressCep) === null || _a === void 0 ? void 0 : _a.trim(), addressCity: (_b = values.addressCity) === null || _b === void 0 ? void 0 : _b.trim(), addressComplement: (_c = values.addressComplement) === null || _c === void 0 ? void 0 : _c.trim(), addressDistrict: (_d = values.addressDistrict) === null || _d === void 0 ? void 0 : _d.trim(), addressName: (_e = values.addressName) === null || _e === void 0 ? void 0 : _e.trim(), addressNumber: (_f = values.addressNumber) === null || _f === void 0 ? void 0 : _f.trim(), addressState: (_g = values.addressState) === null || _g === void 0 ? void 0 : _g.trim(), ddiRequired: (_h = values.ddiRequired) === null || _h === void 0 ? void 0 : _h.trim(), documentGuestRequired: (_j = values.documentGuestRequired) === null || _j === void 0 ? void 0 : _j.trim(), documentTypeGuestRequired: (_k = values.documentTypeGuestRequired) === null || _k === void 0 ? void 0 : _k.trim(), fullnameRequired: (_l = values.fullnameRequired) === null || _l === void 0 ? void 0 : _l.trim().replaceAll(/\s{2,}/g, ' '), phoneRequired: (_m = values.phoneRequired) === null || _m === void 0 ? void 0 : _m.trim(), guests: values.guests.map((guest) => {
                    var _a, _b, _c, _d, _e, _f;
                    return (Object.assign(Object.assign({}, guest), { fullname: (_a = guest.fullname) === null || _a === void 0 ? void 0 : _a.trim().replaceAll(/\s{2,}/g, ' '), documentTypeGuest: (_b = guest.documentTypeGuest) === null || _b === void 0 ? void 0 : _b.trim(), documentGuest: (_c = guest.documentGuest) === null || _c === void 0 ? void 0 : _c.trim(), email: (_d = guest.email) === null || _d === void 0 ? void 0 : _d.trim(), ddi: (_e = guest.ddi) === null || _e === void 0 ? void 0 : _e.trim(), phone: (_f = guest.phone) === null || _f === void 0 ? void 0 : _f.trim() }));
                }) }));
        });
        formSuite.setFieldsValue(formValues);
        const verifyInformation = [];
        formValues.suites.forEach(values => {
            if (values.phoneRequired !== undefined && userEmail !== undefined) {
                const phoneString = values.ddiRequired + values.phoneRequired.replace(/\D/g, '');
                verifyInformation.push({
                    phone: Number(phoneString),
                    email: userEmail,
                    document: values.documentGuestRequired.toString(),
                });
            }
        });
        const guests = formValues.suites[field.key].guests.map((guest) => {
            let birthday = '';
            if (guest.birthday !== undefined) {
                const birthdayAux = guest.birthday;
                if (birthdayAux)
                    birthday = birthdayAux.toString();
            }
            const { phone, ddi } = guest;
            let phoneString = '';
            if (phone !== undefined) {
                phoneString = `${ddi}${phone.replace(/\D/g, '')}`;
            }
            if (phone !== undefined && guest.email !== undefined && guest.documentGuest !== undefined) {
                verifyInformation.push({
                    phone: Number(phoneString),
                    email: guest.email,
                    document: guest.documentGuest,
                });
            }
            return Object.assign(Object.assign({}, guest), { fullname: guest.fullname, rg: guest.documentGuest, birthday, email: guest.email, phone: phoneString, docType: guest.documentTypeGuest });
        });
        const { ddiRequired, phoneRequired } = formValues.suites[field.key];
        const phoneRequiredString = `${ddiRequired}#${phoneRequired.replace(/\D/g, '')}`;
        const { documentTypeGuestRequired } = formValues.suites[field.key];
        const formValuesParam = {
            email: userEmail,
            suites: [
                {
                    id: formValues.suites[field.key].id,
                    fullnameRequired: formValues.suites[field.key].fullnameRequired,
                    rgRequired: formValues.suites[field.key].documentGuestRequired,
                    birthdayRequired: formValues.suites[field.key].birthdayRequired.toString(),
                    emailRequired: formValues.suites[field.key].emailRequired,
                    phoneRequired: phoneRequiredString,
                    ddiRequired: formValues.suites[field.key].ddiRequired,
                    documentTypeGuestRequired: formValues.suites[field.key].documentTypeGuestRequired,
                    guests,
                    addressCep: formValues.suites[field.key].addressCep,
                    addressCity: formValues.suites[field.key].addressCity,
                    addressDistrict: formValues.suites[field.key].addressDistrict,
                    addressName: formValues.suites[field.key].addressName,
                    addressState: formValues.suites[field.key].addressState,
                    addressComplement: formValues.suites[field.key].addressComplement,
                    addressNumber: formValues.suites[field.key].addressNumber,
                    country: formValues.suites[field.key].country,
                    vehicleBrand: (_a = formValues.suites[field.key].vehicleBrand) === null || _a === void 0 ? void 0 : _a.trim(),
                    vehicleColor: (_b = formValues.suites[field.key].vehicleColor) === null || _b === void 0 ? void 0 : _b.trim().replace(' ', '-'),
                    vehiclePlate: formValues.suites[field.key].vehiclePlate,
                    hostingTourism: formValues.suites[field.key].hostingTourism,
                    hostingPrivacy: formValues.suites[field.key].hostingPrivacy,
                    hostingPurchases: formValues.suites[field.key].hostingPurchases,
                    hostingWork: formValues.suites[field.key].hostingWork,
                    checkInTime: formValues.suites[field.key].checkInTime,
                    checkOutTime: formValues.suites[field.key].checkOutTime,
                    verifyInformation,
                },
            ],
        };
        const bookId = (0, helpers_1.decrypty)(localStorage.getItem('XP360:beds_bookId'));
        if (!bookId) {
            history.push(RoutesPaths_1.routesPaths.bookSuite);
            return;
        }
        const { confirmValues } = confirmValuesContext;
        const bookingSaved = (0, helpers_1.decrypty)(localStorage.getItem('XP360:bookingSaved')) === 'true';
        confirmValues.totalPrice = confirmValues.originalTotalPrice;
        try {
            const params = BookingRequestBuilder_1.default.getBookingRequest({
                bookId,
                formValues: formValuesParam,
                confirmValues,
                bookingSaved,
                key: field.key,
            });
            setNeedDebitPhoneBR(ddiRequired !== '55');
            setNeedPaymentDocCPF(documentTypeGuestRequired !== 'CPF');
            const response = yield BookingService_1.default.putBooking(params);
            setLoading(false);
            if (response.isError) {
                (0, BookingExceptionHandle_1.default)(response);
            }
            else {
                localStorage.setItem(users_1.keyVariables.paymentGuestValues, (0, helpers_1.encrypty)(JSON.stringify(formValues)));
                localStorage.setItem('XP360:bookingSaved', (0, helpers_1.encrypty)('true'));
                if (setRefundProtectEnabled) {
                    setRefundProtectEnabled(true);
                }
                if (setShowRefundComponent) {
                    setShowRefundComponent(true);
                }
                setShow(false);
            }
        }
        catch (err) {
            setLoading(false);
            setShow(true);
            const param = err.response && err.response.data ? err.response.data : undefined;
            (0, BookingExceptionHandle_1.default)(param);
        }
        (_c = document.getElementById('guests-itens')) === null || _c === void 0 ? void 0 : _c.scrollIntoView({ behavior: 'smooth' });
    }), [
        confirmValuesContext,
        field.key,
        formSuite,
        history,
        setNeedDebitPhoneBR,
        setNeedPaymentDocCPF,
        setRefundProtectEnabled,
        setShowRefundComponent,
    ]);
    const getTotalGuests = (0, react_1.useCallback)(() => {
        const guests = formSuite.getFieldValue([formKey, field.key, 'guests']);
        const requiredGuestsValidation = guests.map((guest, index) => {
            return guestFieldsToValidate.some(fieldName => {
                return (0, helpers_1.myTrim)(formSuite.getFieldValue([formKey, field.key, 'guests', index, fieldName]));
            });
        });
        const totalNotEmpty = requiredGuestsValidation.reduce((total, value) => (value ? total + 1 : total), 0);
        const quantityGuestsRegistered = totalNotEmpty + 1;
        setFilledGuestsNumber(quantityGuestsRegistered);
        localStorage.setItem('XP360:filledGuestsNumber', (0, helpers_1.encrypty)(quantityGuestsRegistered.toString()));
    }, [field.key, formKey, formSuite]);
    const validationForm = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setRequiredGuests(Array(guestsQty - 1).fill(false));
        const handleErrorAccordion = (error) => {
            const tabActiveError = (0, helpers_1.getTabActiveGuestError)(error);
            if (tabActiveError)
                setTabActivePane(String(tabActiveError));
        };
        const guest1 = new Promise((resolve, reject) => {
            formSuite
                .validateFields([
                [formKey, field.key, 'fullnameRequired'],
                [formKey, field.key, 'documentGuestRequired'],
                [formKey, field.key, 'birthdayRequired'],
                [formKey, field.key, 'emailRequired'],
                [formKey, field.key, 'phoneRequired'],
                [formKey, field.key, 'checkInTime'],
                [formKey, field.key, 'checkOutTime'],
                [formKey, field.key, 'addressCep'],
                [formKey, field.key, 'addressName'],
                [formKey, field.key, 'addressNumber'],
                [formKey, field.key, 'addressDistrict'],
            ])
                .then(() => __awaiter(void 0, void 0, void 0, function* () {
                resolve(true);
            }))
                .catch(error => {
                if (error.errorFields && error.errorFields.length > 0) {
                    reject(error);
                }
                resolve(true);
            });
        });
        const guestsPromise = new Promise((resolve, reject) => {
            const guests = formSuite.getFieldValue([formKey, field.key, 'guests']);
            const requiredGuestsValidation = guests.map((guest, index) => {
                return guestFieldsToValidate.some(fieldName => {
                    return (0, helpers_1.myTrim)(formSuite.getFieldValue([formKey, field.key, 'guests', index, fieldName]));
                });
            });
            setRequiredGuests(requiredGuestsValidation);
            const totalNotEmpty = requiredGuestsValidation.reduce((total, value) => (value ? total + 1 : total), 0);
            if (totalNotEmpty > 0) {
                formSuite
                    .validateFields([
                    ...guests.reduce((arrayTotal, guest, index) => [
                        ...arrayTotal,
                        ...guestFieldsToValidate.map(fieldName => [formKey, field.key, 'guests', index, fieldName]),
                    ], []),
                ])
                    .then(() => {
                    resolve(true);
                })
                    .catch(error => {
                    if (error.errorFields && error.errorFields.length > 0) {
                        reject(error);
                    }
                    resolve(true);
                });
            }
            else {
                resolve(true);
            }
        });
        const vehicle = new Promise((resolve, reject) => {
            const vehicleFieldsToValidate = ['vehicleBrand', 'vehiclePlate', 'vehicleColor'];
            const someFieldsIsNotEmpty = vehicleFieldsToValidate.some(guestField => formSuite.getFieldValue([formKey, field.key, guestField]));
            if (someFieldsIsNotEmpty) {
                setVehicleIsRequired(true);
                formSuite
                    .validateFields([...vehicleFieldsToValidate.map(vechicleField => [formKey, field.key, vechicleField])])
                    .then(() => {
                    resolve(true);
                })
                    .catch(error => {
                    if (error.errorFields && error.errorFields.length > 0) {
                        reject(error);
                    }
                    resolve(true);
                });
            }
            else {
                resolve(true);
            }
        });
        const interestsValidation = new Promise((resolve, reject) => {
            const interestsFields = ['hostingPrivacy', 'hostingTourism', 'hostingPurchases', 'hostingWork'];
            const someChecked = interestsFields.some(interestsField => formSuite.getFieldValue(interestsField));
            if (!someChecked)
                formSuite
                    .validateFields([[formKey, field.key, 'bookingReason']])
                    .then(() => {
                    resolve(true);
                })
                    .catch(error => {
                    if (error.errorFields && error.errorFields.length > 0) {
                        reject(error);
                    }
                    resolve(true);
                });
            else
                resolve(true);
        });
        yield Promise.all([guest1, guestsPromise, vehicle, interestsValidation])
            .then(() => {
            getTotalGuests();
            handleSubmitData();
        })
            .catch(error => {
            setLoading(false);
            const descriptionElement = (0, helpers_1.messageErrorsValidationsFieldsCheckin)(error);
            message_utils_1.default.error({
                message: descriptionElement,
            });
            handleErrorAccordion(error);
        });
    }), [field.key, formKey, formSuite, getTotalGuests, guestsQty, handleSubmitData]);
    const showForm = (0, react_1.useCallback)(() => {
        setShow(!show);
    }, [show]);
    const changeTab = (0, react_1.useCallback)(key => {
        setTabActivePane(key);
    }, []);
    return (react_1.default.createElement("div", { className: "SuiteTabs" },
        react_1.default.createElement(antd_1.Spin, { spinning: loading, size: "large", style: { position: 'fixed' } },
            react_1.default.createElement(antd_1.Col, { key: field.key, style: { marginBottom: '15px' }, span: 24 },
                react_1.default.createElement(antd_1.Row, { justify: "space-between", align: "middle" },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(antd_1.Col, { xs: {
                                span: 24,
                                flex: '1',
                            }, sm: {
                                span: 24,
                                flex: '1',
                            }, lg: 11 },
                            react_1.default.createElement(suiteCollapseStyle_1.ButtomSuiteForm, { onClick: showForm, type: "primary", icon: react_1.default.createElement(icons_1.CaretDownOutlined, null) },
                                react_1.default.createElement(antd_1.Row, null,
                                    react_1.default.createElement(PaymentStyled_1.CustomSVG, { svg: bed_white_svg_1.default }),
                                    suiteName))),
                        react_1.default.createElement(antd_1.Col, { xs: {
                                span: 24,
                                flex: '1',
                            }, sm: {
                                span: 24,
                                flex: '1',
                            }, lg: 11 },
                            react_1.default.createElement(suiteCollapseStyle_1.DivMarginMobile, { id: "guests-itens" },
                                react_1.default.createElement("span", null, `${filledGuestsNumber} ${filledGuestsNumber > 1 ? 'Hóspedes Registrados' : 'Hóspede Registrado'}`),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(PaymentStyled_1.CustomSVG, { svg: bed_black_svg_1.default }),
                                    react_1.default.createElement(antd_1.Typography.Text, null, `${arrayID.length}
                    ${arrayID.length === 1 ? 'Suíte' : 'Suítes'}`)),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(PaymentStyled_1.CustomSVG, { svg: guest_svg_1.default }),
                                    react_1.default.createElement(antd_1.Typography.Text, null, `Até ${arrayID.length * guestsQty} hóspedes`))))))),
            react_1.default.createElement(suiteCollapseStyle_1.FormBody, { showForm: show, enable: disableForm },
                react_1.default.createElement(Title_1.default, { level: 5 }, "Primeiro H\u00F3spede"),
                react_1.default.createElement("div", { style: { display: 'block' } },
                    react_1.default.createElement(SuiteFormRequired_1.default, { field: field, formKey: formKey })),
                react_1.default.createElement(antd_1.Divider, null),
                react_1.default.createElement(antd_1.Form.List, { name: [field.key, 'guests'] }, guestFields => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(antd_1.Tabs, { type: "card", activeKey: tabActivePane, onChange: changeTab, className: "guests-tabs" }, guestFields.map((guestField, index) => (react_1.default.createElement(TabPane, { tab: (react_1.default.createElement("div", { onClick: validateAllGuests, className: `tabPaneDiv ${requiredGuests[index] ? 'tabPaneStyleNotEmpty' : ''}` },
                            `${ordinalNames[index + 1]} Hóspede`,
                            requiredGuests[index] && validGuests[index] ? (react_1.default.createElement("div", { className: "valid-icon" },
                                react_1.default.createElement(CheckBoldIcon_1.default, null))) : (''))), key: guestField.key, className: "tabPaneStyle" },
                        react_1.default.createElement(Title_1.default, { level: 5 }, `${ordinalNames[index + 1]} Hóspede`),
                        react_1.default.createElement("div", { style: { display: 'block' } },
                            react_1.default.createElement(SuiteForm_1.default, { form: form, isRequired: requiredGuests[index], setIsRequired: (value) => setRequiredGuest(index, value), field: field, guestField: guestField, formKey: formKey }))))))))),
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CheckInCheckOut_1.default, { field: field, formKey: formKey }),
                    react_1.default.createElement(VehicleForm_1.default, { field: field, formKey: formKey, vehicleIsRequired: vehicleIsRequired, setVehicleIsRequired: setVehicleIsRequired }),
                    react_1.default.createElement(antd_1.Row, null,
                        react_1.default.createElement(BookingReason_1.default, { formKey: formKey })),
                    react_1.default.createElement(antd_1.Col, { span: 24 },
                        react_1.default.createElement(antd_1.Row, { justify: "end" },
                            react_1.default.createElement(antd_1.Col, { span: 5 },
                                react_1.default.createElement(antd_1.Form.Item, { name: [field.name, 'save'] },
                                    react_1.default.createElement(antd_1.Button, { type: "primary", onClick: validationForm, className: "btn-save", style: { textAlign: 'center', marginTop: '15px' } }, "Salvar"))))))))));
};
exports.default = SuiteTabs;
